import { Nullable, ServiceCategory, ServiceData, ServiceStatus } from 'chaika-frontend-types/frontend-cms';

import { LongList } from '@store/abstract/LongList';
import { makeObservable } from 'mobx';

interface FilterParams {
    ids?: string[];
    executeIds?: string[];
    category?: ServiceCategory;
    status?: ServiceStatus;
    informedConsentRequired?: boolean;
    needInformedConsent?: boolean;
    statuses?: ServiceStatus[];
    specialtyId?: Nullable<string>;
    isOnline?: boolean;
}

export class ServiceList extends LongList<ServiceData, ServiceData, FilterParams> {
    constructor(params?: ServiceData[]) {
        super(params);
        makeObservable(this);

        this.filterParams = {
            statuses: [ServiceStatus.Active],
        };
    }

    public isConsultation(serviceId: string): boolean {
        const service = this.get(serviceId);
        return !!service && service.category === ServiceCategory.Consultation;
    }

    public isActive(serviceId: string): boolean {
        const service = this.get(serviceId);
        return service?.status === ServiceStatus.Active;
    }

    protected create(params: ServiceData): ServiceData {
        return params;
    }

    // protected filterValue(
    //     { id, category: serviceCategory, status: serviceStatus, ...service }: ServiceData,
    //     { ids, executeIds, category, status, informedConsentRequired, statuses, specialtyId, isOnline }: FilterParams,
    // ): boolean {
    //     const statusFilter = status || statuses ? new Set(statuses ? statuses : [status]) : undefined;
    //     return (
    //         (ids ? ids.includes(id) : true) &&
    //         (executeIds ? !executeIds.includes(id) : true) &&
    //         (category ? category === serviceCategory : true) &&
    //         (!isNil(informedConsentRequired) ? informedConsentRequired === service.informedConsentRequired : true) &&
    //         (statusFilter ? statusFilter.has(serviceStatus) : true) &&
    //         (specialtyId ? !!service?.specialtyIds?.includes(specialtyId) : true) &&
    //         (isDefined(isOnline) ? service.isOnline === isOnline : true)
    //     );
    // }

    protected filterValue(service: ServiceData, filterParams: FilterParams): boolean {
        const statuses =
            filterParams.statuses || filterParams.status ? filterParams.statuses || [filterParams.status] : undefined;

        return (
            this.filterFieldValueByArray(service, filterParams.ids, 'id') &&
            this.filterFieldValueByExclusiveArray(service, filterParams.executeIds, 'id') &&
            this.filterFieldValue(service, filterParams.category, 'category') &&
            this.filterFieldValueByArray(service, statuses, 'status') &&
            this.filterArrayFieldValue(service, filterParams.specialtyId, 'specialtyIds') &&
            this.filterFieldValue(service, filterParams.isOnline, 'isOnline') &&
            this.filterFieldValue(service, filterParams.informedConsentRequired, 'informedConsentRequired') &&
            (this.filterFieldValue(service, filterParams.needInformedConsent, 'informedConsentRequired') ||
                this.filterFieldValue(service, filterParams.needInformedConsent, 'informedConsentNecessarily'))
        );
    }
}
